var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button",class:{active: _vm.state , 'hover-disable': _vm.hoverDisable},on:{"click":function($event){return _vm.setRadio()}}},[_c('div',{staticClass:"radio-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }